import { apiClient } from "../../Service";
import { collectionToParticipants, collectionToTeams, } from "./Transformer";
async function getTeams(missionId) {
    const client = apiClient();
    const params = {
        mission_id: missionId,
    };
    return client.get("/appv2/mission/teams", { params }).then((response) => {
        return collectionToTeams(response.teams);
    });
}
async function getTeamParticipants(teamId, missionId) {
    const client = apiClient();
    const params = {
        team_id: teamId,
        mission_id: missionId,
    };
    return client
        .get("/appv2/mission/team-participants", { params })
        .then((response) => {
        return collectionToParticipants(response.participants);
    });
}
export const MissionService = {
    getTeamParticipants,
    getTeams,
};
